<template>
  <div class="strategy-fields">
    <FormItem label="签到位广告" class="module-switch-item" :label-width="110">
      <i-switch v-model="config.signInAd.enabled" :disabled="disabled" />
    </FormItem>
    <FormItem
      v-if="config.signInAd.enabled"
      label=""
      class="module-panel-item"
      :label-width="110"
    >
      <div class="module-panel">
        <div class="panel-row">
          <div class="panel-label">广告展示顺序</div>
          <div class="panel-content">
            <RadioGroup v-model="config.signInAd.priority" :disabled="disabled">
              <Radio label="video" :disabled="disabled">优先激励视频</Radio>
              <Radio label="h5" :disabled="disabled">优先H5</Radio>
            </RadioGroup>
          </div>
        </div>

        <div class="panel-row">
          <div class="panel-label">H5停留时长≥</div>
          <div class="panel-content panel-content--wrap">
            <InputNumber
              v-model="config.signInAd.h5StaySeconds"
              :min="1"
              :max="60"
              :precision="0"
              :disabled="disabled"
              size="small"
            />
            <span class="panel-unit">秒</span>
          </div>
        </div>

        <div class="panel-row">
          <div class="panel-label"></div>
          <div class="panel-content panel-content--wrap">
            <span>每日可领</span>
            <InputNumber
              v-model="config.signInAd.dailyLimit"
              :min="1"
              :max="99"
              :precision="0"
              :disabled="disabled"
              size="small"
              @on-change="handleDailyLimitChange"
            />
            <span class="panel-unit">次</span>

            <span class="panel-gap">每次需看</span>
            <InputNumber
              v-model="config.signInAd.adsPerReward"
              :min="1"
              :max="20"
              :precision="0"
              :disabled="disabled"
              size="small"
            />
            <span class="panel-unit">条</span>
          </div>
        </div>

        <div class="panel-row reward-panel-row">
          <div class="panel-label">奖励赠币</div>
          <div class="panel-content reward-panel">
            <div
              v-for="(rule, index) in config.signInAd.rewardRules"
              :key="groupKey + '-sign-' + index"
              class="reward-rule-row"
            >
              <span>{{ getRewardRuleNthText(index) }}</span>
              <span class="reward-label">奖励币数量</span>
              <InputNumber
                v-model="rule.coinAmount"
                :min="1"
                :max="99999"
                :precision="0"
                :disabled="disabled"
                size="small"
              />
              <Button
                v-if="!disabled"
                type="text"
                class="reward-delete"
                @click="removeRewardRule(index)"
              >
                删除
              </Button>
            </div>
            <Button
              v-if="!disabled && canAddRewardRule"
              type="text"
              class="reward-add"
              @click="addRewardRule"
            >
              +添加规则
            </Button>
          </div>
        </div>
      </div>
    </FormItem>

    <FormItem
      label="剧集解锁广告"
      class="module-switch-item"
      :label-width="110"
    >
      <i-switch v-model="config.unlockAd.enabled" :disabled="disabled" />
    </FormItem>
    <FormItem
      v-if="config.unlockAd.enabled"
      label=""
      class="module-panel-item"
      :label-width="110"
    >
      <div class="module-panel">
        <div class="panel-row">
          <div class="panel-label">广告展示顺序</div>
          <div class="panel-content">
            <RadioGroup v-model="config.unlockAd.priority" :disabled="disabled">
              <Radio label="video" :disabled="disabled">优先激励视频</Radio>
              <Radio label="h5" :disabled="disabled">优先H5</Radio>
            </RadioGroup>
          </div>
        </div>

        <div class="panel-row">
          <div class="panel-label">H5停留时长≥</div>
          <div class="panel-content panel-content--wrap">
            <InputNumber
              v-model="config.unlockAd.h5StaySeconds"
              :min="1"
              :max="60"
              :precision="0"
              :disabled="disabled"
              size="small"
            />
            <span class="panel-unit">秒</span>
          </div>
        </div>

        <div class="panel-row panel-row--wide-label">
          <div class="panel-label">
            <Tooltip transfer max-width="250" placement="right">
              <div slot="content">
                <img
                  src="@/assets/images/tooltip/paywall-float.png"
                  style="width: 220px; border-radius: 4px"
                />
              </div>
              <Icon
                type="ios-information-circle-outline"
                style="margin-right: 4px; color: #2d8cf0; cursor: pointer"
              />
            </Tooltip>
            付费面板悬浮窗
          </div>
          <div class="panel-content">
            <i-switch
              v-model="config.unlockAd.payPanelFloat"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="panel-row">
          <div class="panel-label"></div>
          <div class="panel-content panel-content--wrap">
            <span>看</span>
            <InputNumber
              v-model="config.unlockAd.adsPerUnlock"
              :min="1"
              :max="20"
              :precision="0"
              :disabled="disabled"
              size="small"
            />
            <span>个广告解锁</span>
            <InputNumber
              v-model="config.unlockAd.episodesPerUnlock"
              :min="1"
              :max="20"
              :precision="0"
              :disabled="disabled"
              size="small"
            />
            <span class="panel-unit">集</span>
          </div>
        </div>

        <div class="panel-row">
          <div class="panel-label"></div>
          <div class="panel-content panel-content--wrap">
            <span>每日最多解锁次数</span>
            <InputNumber
              v-model="config.unlockAd.dailyUnlockLimit"
              :min="1"
              :max="99"
              :precision="0"
              :disabled="disabled"
              size="small"
            />
          </div>
        </div>
      </div>
    </FormItem>

    <FormItem label="开屏广告" class="module-switch-item" :label-width="110">
      <i-switch v-model="config.splashAd.enabled" :disabled="disabled" />
    </FormItem>
    <FormItem
      v-if="config.splashAd.enabled"
      label=""
      class="module-panel-item"
      :label-width="110"
    >
      <div class="module-panel module-panel--simple">
        <div class="panel-row">
          <div class="panel-label">广告类型</div>
          <div class="panel-content">
            <CheckboxGroup
              v-model="config.splashAd.triggerTypes"
              :disabled="disabled"
            >
              <Checkbox label="cold" :disabled="disabled">冷启动</Checkbox>
              <Checkbox label="hot" :disabled="disabled">热启动</Checkbox>
            </CheckboxGroup>
          </div>
        </div>
      </div>
    </FormItem>

    <FormItem label="信息流广告" class="module-switch-item" :label-width="110">
      <i-switch v-model="config.feedAd.enabled" :disabled="disabled" />
    </FormItem>
    <FormItem
      v-if="config.feedAd.enabled"
      label=""
      class="module-panel-item"
      :label-width="110"
    >
      <div class="module-panel module-panel--simple">
        <div class="panel-row">
          <div class="panel-label">广告位置</div>
          <div class="panel-content">
            <CheckboxGroup
              v-model="config.feedAd.positions"
              :disabled="disabled"
            >
              <Checkbox label="PLAY_PAGE" :disabled="disabled">
                <Tooltip transfer max-width="250" placement="right">
                  <div slot="content">
                    <img
                      src="@/assets/images/tooltip/feed-play.jpg"
                      style="width: 220px; border-radius: 4px"
                    />
                  </div>
                  <Icon
                    type="ios-information-circle-outline"
                    style="margin-right: 2px; color: #2d8cf0; cursor: pointer"
                  />
                </Tooltip>
                播放页
              </Checkbox>
              <Checkbox label="ACTIVITY_PAGE" :disabled="disabled">
                <Tooltip transfer max-width="250" placement="right">
                  <div slot="content">
                    <img
                      src="@/assets/images/tooltip/feed-activity.png"
                      style="width: 220px; border-radius: 4px"
                    />
                  </div>
                  <Icon
                    type="ios-information-circle-outline"
                    style="margin-right: 2px; color: #2d8cf0; cursor: pointer"
                  />
                </Tooltip>
                活动页
              </Checkbox>
            </CheckboxGroup>
          </div>
        </div>
      </div>
    </FormItem>

    <FormItem label="插屏广告" class="module-switch-item" :label-width="110">
      <i-switch v-model="config.interstitialAd.enabled" :disabled="disabled" />
    </FormItem>
    <FormItem
      v-if="config.interstitialAd.enabled"
      label=""
      class="module-panel-item"
      :label-width="110"
    >
      <div class="module-panel module-panel--simple">
        <div class="panel-row">
          <div class="panel-label">
            <span style="color: #ed4014;">*</span>触发场景
          </div>
          <div class="panel-content">
            <CheckboxGroup
              v-model="config.interstitialAd.triggerScenes"
              :disabled="disabled"
            >
              <Checkbox label="BACK_HOME" :disabled="disabled">返回主页</Checkbox>
              <Checkbox label="ACTIVITY_PAGE" :disabled="disabled">活动页</Checkbox>
              <Checkbox label="CLAIM_REWARD" :disabled="disabled">领奖励</Checkbox>
            </CheckboxGroup>
          </div>
        </div>
      </div>
    </FormItem>
  </div>
</template>

<script>
export default {
  name: 'AdStrategyFields',
  props: {
    config: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    groupKey: {
      type: String,
      default: 'group'
    }
  },
  computed: {
    canAddRewardRule() {
      const dailyLimit = Number(this.config.signInAd.dailyLimit) || 1
      return this.config.signInAd.rewardRules.length < dailyLimit
    }
  },
  mounted() {
    this.handleDailyLimitChange()
  },
  watch: {
    'config.signInAd.dailyLimit'() {
      this.handleDailyLimitChange()
    }
  },
  methods: {
    getRewardRuleNthText(index) {
      const rules = this.config.signInAd.rewardRules || []
      const dailyLimit =
        Number(this.config.signInAd.dailyLimit) || rules.length || 1
      const rangeStart = index + 1
      const isLast = index === rules.length - 1

      if (isLast && rules.length < dailyLimit) {
        return '第' + rangeStart + '~' + dailyLimit + '次'
      }

      return '第' + rangeStart + '次'
    },
    handleDailyLimitChange() {
      const limit = Math.max(Number(this.config.signInAd.dailyLimit) || 1, 1)
      const rules = Array.isArray(this.config.signInAd.rewardRules)
        ? this.config.signInAd.rewardRules.slice(0, limit)
        : []

      if (!rules.length) {
        rules.push({ coinAmount: null })
      }

      this.$set(this.config.signInAd, 'rewardRules', rules)
    },
    addRewardRule() {
      if (!this.canAddRewardRule) return

      this.$set(this.config.signInAd, 'rewardRules', [
        ...(this.config.signInAd.rewardRules || []),
        { coinAmount: null }
      ])
    },
    removeRewardRule(index) {
      if (this.config.signInAd.rewardRules.length <= 1) {
        this.$Message.warning('至少保留一条奖励规则')
        return
      }

      this.config.signInAd.rewardRules.splice(index, 1)
    }
  }
}
</script>

<style scoped lang="less">
.strategy-fields {
  display: flex;
  flex-direction: column;
}

.module-switch-item {
  margin-bottom: 10px;
}

.module-switch-item /deep/ .ivu-form-item-content {
  min-height: 24px;
  line-height: 24px;
}

.module-panel-item {
  margin-top: -2px;
  margin-bottom: 14px;
}

.module-panel {
  padding: 14px 16px 12px;
  background: #eef3fb;
  border-radius: 8px;
}

.module-panel--simple {
  padding-top: 12px;
  padding-bottom: 6px;
}

.panel-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}

.panel-row:last-child {
  margin-bottom: 0;
}

.panel-row--wide-label .panel-label {
  width: 132px;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.panel-label {
  width: 92px;
  line-height: 32px;
  color: #515a6e;
  flex-shrink: 0;
}

.panel-content {
  flex: 1;
  display: flex;
  align-items: center;
  min-height: 32px;
}

.panel-content--wrap {
  flex-wrap: wrap;
  gap: 8px;
}

.panel-unit {
  color: #808695;
}

.panel-gap {
  margin-left: 20px;
}

.reward-panel-row {
  align-items: flex-start;
}

.reward-panel {
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
}

.reward-rule-row {
  display: flex;
  align-items: center;
  width: 100%;
  flex-wrap: nowrap;
  gap: 8px;
  margin-bottom: 8px;
}

.reward-rule-row:last-child {
  margin-bottom: 0;
}

.reward-rule-row > span:first-child {
  white-space: nowrap;
}

.reward-label {
  white-space: nowrap;
  margin-left: 8px;
}

.reward-rule-row /deep/ .ivu-input-number {
  width: 80px;
  flex-shrink: 0;
}

.reward-add {
  padding-left: 0;
  color: #2d8cf0;
}

.reward-delete {
  margin-left: auto;
  padding-left: 0;
  flex-shrink: 0;
  color: #ed4014;
}
</style>
